module.exports = __webpack_public_path__ + "static/media/incident_category-labor.c60eef5e.svg";